import React, { PureComponent } from 'react';
import { approveEmployeeLeave, deleteLeave } from '../../actions/leaveAction'
import { getDashboardData } from '../../actions/dashboardActions'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class EventComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      EmployeeId: '',
      LeaveId: '',
      year: '',
      showMenu: false
    }
    this.toggleModal = this.toggleModal.bind(this);
  }
  toggleModal = () => {
    this.setState({ showMenu: !this.state.showMenu });
  }
  onClickDialog = async (e, leaveId, employeeId, EventDate) => {
    e.stopPropagation();
    var year = new Date(EventDate).getFullYear();
    await this.setState({ EmployeeId: employeeId, LeaveId: leaveId, year: year });
    this.toggleModal();
  }
  approveLeave = async (e) => {
    await approveEmployeeLeave({ LeaveId: this.state.LeaveId, employeeId: this.state.EmployeeId, IsApproved: true, year: this.state.year });
    this.props.getDashboardData();
    this.setState({ showMenu: false });
  }
  deleteLeave = async (e) => {
    await deleteLeave({ LeaveId: this.state.LeaveId });
    this.props.getDashboardData();
    this.setState({ showMenu: false });
  }
  renderEvent(event) {
    const eventType = event.EventType;
    const isApproved = event.IsApproved === 1 ? 'approved' : 'unapproved';
    switch (eventType) {
      case 'full-day':
      case 'first-half':
      case 'second-half':
        return (
          <div className={`${eventType}-${isApproved}`} title='Leave'>
            <i className="fas fa-umbrella-beach"></i>&nbsp;{event.Name}
            {this.props.userRole === 'Admin' && event.IsApproved === 0 &&
              <i onClick={(e) => this.onClickDialog(e, event.LeaveId, event.EmployeeId, event.EventDate)} className='rotate-point'  >...</i>}
            <i style={{ position: 'absolute' }}>
              {this.state.showMenu ?
                (<div className='show-menu'>
                  <i onClick={this.approveLeave} style={{ color: '#000000', fontStyle: 'initial' }}>Approve</i>
                  <br></br>
                  <i style={{ color: '#000000', fontStyle: 'initial', marginTop: '2px' }} onClick={this.deleteLeave}>Delete</i>
                  <hr style={{ height: '2px', marginTop: '4px', marginBottom: '4px' }}></hr>
                  <i style={{ color: '#000000', fontStyle: 'initial' }} onClick={this.toggleModal}>Cancel</i>
                </div>)
                : (null)
              }
            </i>
          </div>
        );

      default:
        //>> birthday || holiday
        return (
          <div className={`${eventType}`} title={eventType}>
            <i className={`fas ${eventType === 'birthday' ? 'fa-birthday-cake' : 'fa-snowman'}`} ></i>&nbsp;&nbsp;{event.Name}
          </div>
        );
    }
  }
  render() {
    return (
      this.renderEvent(this.props.event)
    )
  }
}
const mapStateToProps = (state) => {
  return {
    userRole: state.dashboardData.userRole,
    empId: state.empId
  }
}
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getDashboardData }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(EventComponent);
